export const CodeMirrorStyle = `
    /*!
     * froala_editor v2.9.1 (https://www.froala.com/wysiwyg-editor)
     * License https://froala.com/wysiwyg-editor/terms/
     * Copyright 2014-2018 Froala Labs
     code view
    */
    .clearfix::after{clear:both;display:block;content:"";height:0}.hide-by-clipping{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}textarea.fr-code{display:none;width:100%;resize:none;-moz-resize:none;-webkit-resize:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border:0;padding:10px;margin:0;font-family:"Courier New",monospace;font-size:14px;background:#fff;color:#000;outline:0}.fr-box.fr-rtl textarea.fr-code{direction:rtl}.fr-box .CodeMirror{display:none}.fr-box.fr-code-view textarea.fr-code{display:block}.fr-box.fr-code-view.fr-inline{-webkit-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);-moz-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16)}.fr-box.fr-code-view .fr-element,.fr-box.fr-code-view .fr-placeholder,.fr-box.fr-code-view .fr-iframe{display:none}.fr-box.fr-code-view .CodeMirror{display:block}.fr-box.fr-inline.fr-code-view .fr-command.fr-btn.html-switch{display:block}.fr-box.fr-inline .fr-command.fr-btn.html-switch{position:absolute;top:0;right:0;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);-moz-box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 1px 1px rgba(0,0,0,.16);display:none;background:#fff;color:#222;-moz-outline:0;outline:0;border:0;line-height:1;cursor:pointer;text-align:left;padding:12px;-webkit-transition:background .2s ease 0s;-moz-transition:background .2s ease 0s;-ms-transition:background .2s ease 0s;-o-transition:background .2s ease 0s;border-radius:0;-moz-border-radius:0;-webkit-border-radius:0;-moz-background-clip:padding;-webkit-background-clip:padding-box;background-clip:padding-box;z-index:2;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-decoration:none;user-select:none;-o-user-select:none;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none}.fr-box.fr-inline .fr-command.fr-btn.html-switch i{font-size:14px;width:14px;text-align:center}.fr-box.fr-inline .fr-command.fr-btn.html-switch.fr-desktop:hover{background:#ebebeb}

    /* codemirror.min.css */
    .CodeMirror{font-family:monospace;height:300px;color:#000}.CodeMirror-lines{padding:4px 0}.CodeMirror pre{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror div.CodeMirror-cursor{border-left:1px solid #000}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.CodeMirror.cm-fat-cursor div.CodeMirror-cursor{width:auto;border:0;background:#7e7}.CodeMirror.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-animate-fat-cursor{width:auto;border:0;-webkit-animation:blink 1.06s steps(1) infinite;-moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite}@-moz-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@-webkit-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-ruler{border-left:1px solid #ccc;position:absolute}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-header{color:#00f}.cm-s-default .cm-quote{color:#090}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:0;position:relative}.CodeMirror-sizer{position:relative;border-right:30px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;margin-bottom:-30px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;height:100%}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:0 0;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent}.CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}.CodeMirror-code{outline:0}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{-moz-box-sizing:content-box;box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-measure pre{position:static}.CodeMirror div.CodeMirror-cursor{position:absolute;border-right:none;width:0}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror ::selection{background:#d7d4f0}.CodeMirror ::-moz-selection{background:#d7d4f0}.cm-searching{background:#ffa;background:rgba(255,255,0,.4)}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:''}span.CodeMirror-selectedtext{background:0 0}
`;

//  custom froala editor
export const froalaEditorStyle = `
    .fr-video-resizer{ display: none }
    .fr-tooltip {
      font-family: 'Lato','Helvetica','Roboto','Arial','Source Han Sans TC','Droid Sans','Noto Sans CJK TC','Noto Sans TC','Noto Sans JP','Microsoft JhengHei','微軟正黑體','Microsoft YaHei','Hiragino Sans GB','sans-serif';
      font-weight: 500;
    }
    .fr-element .fr-video {
      position: relative;
      display: block;
    }
    .fr-box.fr-code-view .CodeMirror {
      border-style: dashed;
      border-color: rgb(144, 156, 174);
      border-image: initial;
      border-width: 1px;
    }
    .fr-view .fr-video.fr-dvb {
      text-align: center;
    }
    .fr-view .fr-video.fr-dvb.fr-fvl {
      text-align: left;
    }
    .fr-view .fr-video.fr-dvb.fr-fvr{
      text-align: right;
    }
    .fr-popup .fr-layer.custom-popup {
      width: 450px;
    }
    .fr-element.fr-view img.fr-dii {
      margin: 0;
    }
    .fr-popup.fr-above {
      z-index: 10000 !important;
    }
    .fr-toolbar .fr-command.fr-btn {
      width: 35px;
      height: 35px;
    }
    .fr-separator.fr-vs {
      height: 30px;
    }
    .fr-command.fr-btn.fr-options {
      width: 16px;
    }
    .fr-toolbar .fr-command.fr-btn i, .fr-toolbar .fr-command.fr-btn svg {
      font-size: 13px;
      width: 12px;
    }
    div[id^="dropdown-menu-align"] .fr-dropdown-content li:last-child {
      display: none;
    }
    div[id^="dropdown-menu-paragraphFormat"] .fr-dropdown-content li {
      font-size: 8px !important;
    }
    a.fr-command[data-param1="H1"] {
      font-size: 3em;
    }
    a.fr-command[data-param1="H2"] {
      font-size: 2.9em;
    }
    a.fr-command[data-param1="H3"] {
      font-size: 2.7em;
    }
    a.fr-command[data-param1="H4"] {
      font-size: 2.6em;
    }
    a.fr-command[data-param1="N"] {
      font-size: 1em;
    }
    a.fr-command[data-param1="DIV"] {
      font-size: 0.88em;
    }
    a.fr-command[data-param1="H5"] {
      font-size: 3.5em;
    }
    a.fr-command[data-param1="H6"] {
      font-size: 5em;
    }
    a.fr-command[data-param1="normal"] {
      line-height: normal !important;
    }
    a.fr-command[data-param1="1.5em"] {
      line-height: 1.5em !important;
    }
    a.fr-command[data-param1="1.75em"] {
      line-height: 1.75em !important;
    }
    a.fr-command[data-param1="2em"] {
      line-height: 2em !important;
    }
    a.fr-command[data-param1="13em"] {
      line-height: 3em !important;
    }
    a.fr-command[data-param1="4em"] {
      line-height: 4em !important;
    }
    a.fr-command[data-param1="5em"] {
      line-height: 5em !important;
    }
    a.fr-command[data-param1="100%"] {
      line-height: 100% !important;
    }
    a.fr-command[data-param1="120%"] {
      line-height: 120% !important;
    }
    a.fr-command[data-param1="130%"] {
      line-height: 130% !important;
    }
    a.fr-command[data-param1="150%"] {
      line-height: 150% !important;
    }
    a.fr-command[data-param1="170%"] {
      line-height: 170% !important;
    }
    a.fr-command[data-param1="180%"] {
      line-height: 180% !important;
    }
    a.fr-command[data-param1="190%"] {
      line-height: 190% !important;
    }
    a.fr-command[data-param1="200%"] {
      line-height: 200% !important;
    }
    a.fr-command[data-param1="220%"] {
      line-height: 220% !important;
    }
    a.fr-command[data-param1="250%"] {
      line-height: 250% !important;
    }
    a.fr-command[data-param1="300%"] {
      line-height: 300% !important;
    }
    a.fr-command[data-param1="400%"] {
      line-height: 400% !important;
    }
    a.fr-command[data-param1="500%"] {
      line-height: 500% !important;
    }
    #outerClose {
      background: rgba(0, 0, 0, .5);
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 999;
    }
`;

export const froalaStyle = `
    // global reset setting
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        font-weight: 300;
    }
    .cover-title {
        padding: 0 1rem;
        margin: 18px 0;
        font-size: 4rem;
        line-height: 1.2;
    }
    .cover-title span {
        font-size: 4rem !important;
    }
    @media screen and (max-width: 480px) {
        .cover-title {
            font-size: 3.25rem;
        }
        .cover-title span {
            font-size: 3.25rem !important;
        }
    }
    .section-title {
        margin: 18px 0;
        font-size: 2.25rem;
        line-height: 1.3;
    }
    .section-title span {
        font-size: 2.25rem !important;
    }
    @media screen and (max-width: 480px) {
        .section-title {
            font-size: 1.85rem;
        }
        .section-title span {
            font-size: 1.85rem !important;
        }
    }
    .section-subtitle {
        margin: 18px 0;
        font-size: 1.75rem;
        line-height: 1.3;
    }
    .section-subtitle span {
        font-size: 1.75rem !important;
    }
    @media screen and (max-width: 480px) {
        .section-subtitle {
            font-size: 1.5rem;
        }
        .section-subtitle span {
            font-size: 1.5rem !important;
        }
    }
    .inner-title {
        margin: 18px 0;
        font-size: 1.5rem;
        line-height: 1.3;
    }
    .inner-title span {
        font-size: 1.5rem !important;
    }
    @media screen and (max-width: 480px) {
        .inner-title {
            font-size: 1.25rem;
        }
        .inner-title span {
            font-size: 1.25rem !important;
        }
    }
    p {
        margin: 18px 0;
        font-size: 1.12rem;
        line-height: 1.5;
    }
    @media screen and (max-width: 480px) {
        p {
            font-size: 1rem;
        }
    }
    .inner {
        margin: 18px 0;
        font-size: 1.12rem;
        line-height: 1.5;
    }
    .inner span {
        font-size: 1.12rem !important;
    }
    @media screen and (max-width: 480px) {
        .inner {
            font-size: 1rem;
        }
        .inner span {
            font-size: 1rem !important;
        }
    }
    .caption {
        margin: 10px 0;
        font-size: 0.88rem;
        line-height: 1.2;
    }
    .caption span {
        font-size: 0.88rem !important;
    }
    .blockquote {
        margin: 30px 0;
        margin-left: 18px;
        border-left: 4px solid;
        padding-left: 1.12rem;
        font-size: 1rem;
        line-height: 1.5;
    }
    .blockquote span {
        font-size: 1rem !important;
    }
    @media screen and (max-width: 480px) {
        .blockquote {
            font-size: 1rem;
        }
        .blockquote span {
            font-size: 1rem !important;
        }
    }
    .title-large {
        margin: 18px 0;
        font-size: 5.25rem;
        line-height: 1;
    }
    .title-large span {
        font-size: 5.25rem !important;
    }
    @media screen and (max-width: 480px) {
        .title-large {
            font-size: 4.5rem;
        }
        .title-large span {
            font-size: 4.5rem !important;
        }
    }
    .title-xlarge {
        margin: 18px 0;
        font-size: 7.5rem;
        line-height: 1;
    }
    .title-xlarge span {
        margin: 18px 0;
        font-size: 7.5rem !important;
        line-height: 1;
    }
    @media screen and (max-width: 480px) {
        .title-xlarge {
            font-size: 6rem;
        }
        .title-xlarge span {
            font-size: 6rem !important;
        }
    }

    table.fr-dashed-borders,
    table.fr-dashed-borders td,
    table.fr-dashed-borders th {
        border-style: dashed;
    }
    table.fr-alternate-rows tbody tr:nth-of-type(2n) {
        background: #f5f5f5;
    }
    table td:empty,
    table th:empty {
        height: 20px;
    }
    table td.fr-highlighted,
    table th.fr-highlighted {
        border: 1px double red;
    }
    table td.fr-thick,
    table th.fr-thick {
        border-width: 2px;
    }
    table th {
        background: #e6e6e6;
    }
    .fr-video {
        text-align: center;
        display: block;
    }
    table.fr-table-default,
    table.fr-table-default td,
    table.fr-table-default th,
    table.fr-table-collapse,
    table.fr-table-collapse td,
    table.fr-table-collapse th,
    table.fr-dashed-borders,
    table.fr-dashed-borders td,
    table.fr-dashed-borders th {
        border-color: #ddd;
    }
    table.fr-table-default {
        border-collapse: collapse;
    }
    table.fr-no-borders,
    table.fr-no-borders td,
    table.fr-no-borders th {
        border-color: rgba(255, 255, 255, 0);
    }

    span.fr-emoticon.fr-deletable.fr-emoticon-img {
        background-repeat: no-repeat !important;
        font-size: inherit;
        height: 1em;
        width: 1em;
        min-height: 20px;
        min-width: 20px;
        display: inline-block;
        margin: -0.1em 0.1em 0.1em;
        line-height: 1;
        vertical-align: middle;
    }

    span.fr-img-caption {
        display: inline-block;
        max-width: 100%;
    }

    span.fr-img-caption .fr-img-wrap > span {
        margin: auto;
        display: block;
        padding: 5px 5px 10px;
        font-size: 14px;
        font-weight: initial;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-opacity: 0.9;
        -moz-opacity: 0.9;
        opacity: 0.9;
        -ms-filter: alpha(Opacity=0);
        width: 100%;
        text-align: center;
    }
`;

export const blockquoteStyle = `
    blockquote {
        padding: 0;
        border-style: solid;
        border-color: #ccc;
        border-width: 0;
        padding-left: 20px;
        padding-right: 8px;
        border-left-width: 5px;
    },
    @media (max-width: 480px) {
        blockquote {
            margin: 10px;
        }
    }
`;

export const textBoxStyle = `
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    word-wrap: break-word;
    letter-spacing: 0.5px;
    line-height: 1.7;
    strong { font-weight: 500 }
    a { text-decoration: none }
    iframe { max-width: 100% }
    img {
        max-width: 100%;
        width: auto;
        height: auto !important;
        object-fit: fill;
        animation: none;
        vertical-align: top;
    }
    ${blockquoteStyle}
`;

export const fixCutShadow = `
    width: 100%;
    position: relative;
    .fr-box.fr-box .fr-element {
        padding: 0 1rem;
        margin: 0;
        overflow: hidden;
        min-height: initial;
    }
    .fr-box.fr-basic.fr-top .fr-wrapper {
        box-shadow: none;
        background: none;
    }
    .fr-view {
        ${textBoxStyle}
        border: 1px dashed #909CAE;
        outline: none;
        .fr-element table td.fr-selected-cell, .fr-element table th.fr-selected-cell {
            border: 1px double #1e88e5 !important;
        }
        & .fr-no-borders:hover, & .fr-no-borders:hover td {
            border-color: #eee !important;
            border-style: dashed !important;
        }
    }
     .fr-code {
        border: 1px dashed #909CAE;
        outline: none;
        overflow: hidden;
        min-height: 64px;
        background: #eee;
    }
     .fr-code-view {
        z-index: 1000;
    }
`;

export const toolbarFixed = `
     .fr-toolbar {
        position: fixed;
        width: 685px !important;
        transform: translateY(-100%);
        z-index: 4;
    }
`;
export const toolEditor = `
    .fr-popup .fr-layer.custom-popup {
      width: 450px;
    }
    .fr-popup.fr-above {
      z-index: 10000 !important;
    }
    .fr-sperate-block {
      margin-bottom: 22px;
    }
    .color-pop {
      position: absolute;
      width: 224px;
      z-index: 10;
      right: -8px;
      top: 0;
      transform: translateX(100%);
      background: #fff;
      border: 1px solid #d4cdcd;
      display: none;
    }
    .fr-popup .fr-input-line input[type=text].color-input {
      width: 115px;
      display: inline-block;
      margin-right: 5px;
    }
    .color-picker {
      display: inline-block;
      position: absolute;
      top: 0;
      cursor: pointer;
    }
    .color-toggle {
      line-height: 0;
    }
    .color-column {
      width: 30px;
      height: 30px;
      float: left;
      border: 1px solid #fff;
    }
    .color-column:last-child {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAADFBMVEXMyszMzszU0tT8/vwq5swEAAAAZElEQVR4Ae3SwQ2EAAgF0Rm2/543Ro04NcjtceH/BEYHh981NSKK96LGc+Ze1Awy8JyIT+pzIkbRFapmUFao+uCwQtU73OjU8AqD1rz7M3X6W0P71+nPbPfEwRrS3/r7h+8ftv/vfQe1Hir3FQAAAABJRU5ErkJggg==');
      background-size: 30px;
      background-repeat: no-repeat;
    }
    .preview-container {
      background-color: #ccc;
      border: 1px solid #bbb;
      padding: 10px;
      text-align: center;
      line-height: 1.5;
      overflow: hidden;
      max-height: 200px;
      margin: 5px 0;
    }
    .fr-toolbar .fr-command.fr-btn i.fr-custom.fa, .fr-popup .fr-command.fr-btn i.fr-custom.fa {
      font-size: 28px;
      margin: 0 4px;
    }
    .fr-popup {
      z-index: 1000 !important;
    }
    .fr-range-label {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 12px;
    }
    .fr-popup .fr-input-line label.color-picker-label {
      width: initial;
    }
    .fr-popup .fr-input-line {
      position: relative;
      padding: 8px 0;
      margin: 5px 0;
    }
    .fr-block {
      display: flex;
      padding: 10px 0px;
      margin-bottom: 10px;
    }
    .fr-block:last-child {
      margin-bottom: 0;
    }
    .fr-option {
      width: 115px;
      position: relative;
    }
    .fr-option:after {
      position: absolute;
      content: "";
      top: 14px;
      right: 7px;
      width: 0px;
      height: 0px;
      border: 4px solid transparent;
      border-color: #000 transparent transparent transparent;
    }
    .fr-select {
      background-color: rgb(248, 248, 248);
      border-width: 1px;
      border-style: solid;
      border-color: rgb(166, 166, 166);
      border-image: initial;
      width: 100%;
      height: 100%;
      padding: 5px 10px 5px 5px;
      background: transparent;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      text-align: center;
      border-radius: 0;
      text-align-last: center;
    }
    .fr-select:focus {
      outline: none;
    }
    .fr-input-title {
      width: 25%;
      font-size: 12px;
      padding: 5px 0;
    }
    .fr-option-container {
      width: 75%;
    }
    .fr-slidecontainer {
      margin-top: 5px;
    }
    input[type="range" i].fr-button-attr.slider::-webkit-slider-container {
      height: 5px;
    }
    input[type="range"].fr-button-attr.slider::-webkit-slider-thumb{
      -webkit-appearance: none;
      width: 14px;
      height: 14px;
      background: #818181;
      border-radius: 50%;
    }
    input[type=range].fr-button-attr.slider {
      outline: none;
      height: 5px;
      border-radius: 5px;
      cursor: pointer;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      -webkit-appearance: none;
      width: 70%;
      background-color: #E3E3E3;
    }
    .fr-div-preview {
      padding:12px;
      text-align:center;
      margin: 8px;
    }
    .fr-div-preview p {
      color: #2AB3A6;
      font-size: 12px;
    }
    .fr-flex {
      display: flex;
    }
    .fr-sperate-line {
      border: 1px solid #ECECEC;
    }
    .fr-popup .fr-colors-tabs .fr-colors-tab.fr-selected-tab[data-param1=border]~[data-param1=background]::after {
      -webkit-transform:translate3d(-100%,0,0);
      -moz-transform:translate3d(-100%,0,0);
      -ms-transform:translate3d(-100%,0,0);
      -o-transform:translate3d(-100%,0,0)
    }
    .fr-background-block {
      padding: 5px;
      width: 320px;
    }
    .fr-background-block .upload-image.uploading .fr-form {
      -webkit-opacity: 1;
      -moz-opacity: 1;
      opacity: 1;
      -ms-filter: "alpha(Opacity=1)";
      background-image: url('https://assets.fevercdn.com/nc/icons/ripple.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-color: #ebebeb;
    }
    .fr-background-block .upload-image.uploading .fr-form input {
      opacity: 0;
    }
    .fr-image-upload-layer.preview-mode {
      border: none;
      padding: 0;
    }
    .fr-image-upload-layer.preview-mode > .upload-image {
      display: none;
    }
    .fr-image-upload-layer > .preview-image {
      display: none;
    }
    .fr-image-upload-layer.preview-mode > .preview-image {
      display: block;
      max-height: 300px;
    }
    .preview-image {
      line-height: 0;
    }
    .preview-image > img {
      width: 100%;
      height: auto;
    }
    .preview-image > .remove-image {
      position: absolute;
      right: -6px;
      top: -6px;
      color: #CCCCCC;
      background: #fff;
      border-radius: 50%;
      font-size: 16px;
      cursor: pointer;
      z-index: 1;
    }
    .preview-image > .remove-image:hover {
      color: #CCCCCC;
      background: #fff;
    }
    .color-input {
      clear:both;
    }
    .fr-blockPadding-block {
      width: 318px;
    }
    .fr-blockPadding-block .fr-slidecontainer {
      text-align: center;
    }
    input[type=range].padding-range.slider {
      width: 90%;
    }
    .fr-blockPadding-block .fr-range-label {
      margin-left: 15px;
    }
    @media (max-height: 768px) {
      .fr-popup .fr-layer.custom-popup .fr-option-container {
        display: flex;
        flex-wrap: wrap;
      }
      .fr-laptop-group {
        width: 50%;
      }
      .fr-popup .fr-layer.custom-popup {
        width: 600px;
        padding: 5px;
      }
      input[type=range].fr-button-attr.slider {
        width: 90%;
      }
      .fr-div-preview {
        margin: 0;
      }
      .fr-laptop-full {
        width: 100%;
      }
      .fr-popup .fr-laptop-group > div {
        margin: 5px 0;
      }
      .fr-popup .fr-laptop-group:first-of-type > div {
        margin-right: 15px;
      }
    }
`;
